<div class="button-toggle-wrapper">
  <ng-container *ngFor="let button of buttonValues; let i = index">
    <button
      m
      type="button"
      class="toggle-button"
      [class.active]="isSelected(button.id)"
      (click)="selectButton(button.id)">
      {{ button.label }}
    </button>
    <div
      *ngIf="i < buttonValues.length - 1"
      class="divider">
    </div>
  </ng-container>

</div>
